import React, {Component} from 'react';
import styled from "styled-components";
import ReactSlider from 'react-slider'

import DataSetting from "./DataSetting.jsx";

const PageWrapper = styled.div`
    font-family: Arial;
    font-size: 1rem;
    user-select: none;
    overflow: hidden;
    height: 100%;
    width: 100%;
    margin: 2rem;
`;

const PageTitle = styled.div`
    font-size: 1.5rem;
    letter-spacing: 0.5rem;
    color: #aaaaaa;
    text-transform: uppercase;
    border-bottom: 0.15rem solid lightgrey;
    margin-bottom: 1rem;
`;

const LeftSide = styled.div`
    display: inline-block;
    vertical-align: top;
`;

const MiddleSide = styled.div`
    display: inline-block;
    vertical-align: top;
`;

const RightSide = styled.div`
    display: inline-block;
    vertical-align: top;
`;

const StyledSlider = styled(ReactSlider)`
    display: inline-block;
    width: 20rem;
    height: 1rem;
`;

const StyledThumb = styled.div`
    height: 1.25rem;
    line-height: 1rem;
    text-align: center;
    background-color: #444;
    color: #eee;
    cursor: grab;
    font-size: 0.85rem;
    padding: 0.15rem 0.25rem 0;
    border-radius: 0.25rem;
`;

const StyledTrack = styled.div`
    top: 0.25rem;
    bottom: 0;
    background-color: ${props => props.index === 2 ? '#f00' : props.index === 1 ? '#ddd' : '#aaa'};
`;

const PreviewButton = styled.div`
    padding: 0.5rem 1rem;
    margin: 1rem;
    border-radius: 0.5rem;
    background-color: darkcyan;
    border: 0.15rem solid black;    
    font-size: 1.2rem;
    color: #eee;
    cursor: pointer;
`;

const preview_url_php = "http://dev.mikehallstudio.com/react-apps/src/moire/moire.php";

const OP_SUM = 1;
const OP_DIFF = 2;
const OP_PROD = 3;
const OP_DIV = 4;
const OP_POW = 5;
const OP_LOG = 6;
const OP_DIFF_SQ = 7;

export class Moire extends Component {

    state = {
        resolution: 500,
        zoom: 1,
        angle: 0,
        radius: 0.25,
        center_x: -0.5,
        center_y: -0.5,
        mouse_x: 0,
        mouse_y: 0,
        preview_url: preview_url_php + "?frame_size=500&x_offset=-0.5&y_offset=-0.5",
    };

    componentDidMount() {
        document.title = "Moire";
    }

    change_resolution(value) {
        console.log("change_resolution", value);
        this.setState({resolution: value})
    }

    change_zoom(value) {
        console.log("change_zoom", value);
        this.setState({zoom: value})
    }

    change_angle(value) {
        console.log("change_angle", value);
        this.setState({angle: value})
    }

    change_radius(value) {
        console.log("change_radius", value);
        this.setState({radius: value})
    }

    change_center_x(value) {
        console.log("change_center_x", value);
        this.setState({center_x: value})
    }

    change_center_y(value) {
        console.log("change_center_y", value);
        this.setState({center_y: value})
    }

    preview_image() {
        const preview_url = preview_url_php + "?" +
            "operation=" + this.state.operation +
            "&pixel_size=2" +
            "&x_center=" + this.state.center_x +
            "&y_center=" + this.state.center_y +
            "&zoom=" + this.state.zoom +
            "&radius=" + this.state.radius +
            "&angle=" + this.state.angle;
        console.log("preview_url", preview_url)
        this.setState({
            preview_url: preview_url
        })
    }

    on_mouse_over_image(e) {
        this.setState({
            mouse_x: e.clientX - e.target.offsetLeft,
            mouse_y: e.clientY - e.target.offsetTop
        })
    }

    change_operation(e) {
        const value = e.target.value;
        console.log("change_operation", value);
        this.setState({operation: value})
    }

    render() {
        const thumb = (props, state) => <StyledThumb {...props}>{state.valueNow}</StyledThumb>;
        const track = (props, state) => <StyledTrack {...props} index={state.index}/>;
        const zoom_setting = <StyledSlider
            max={1000.0} min={0.1} step={0.1}
            orientation={'horizontal'}
            value={this.state.zoom}
            renderTrack={track} renderThumb={thumb}
            onChange={value => this.change_zoom(value)}
        />
        const angle_setting = <StyledSlider
            max={3.14} min={-3.14} step={0.01}
            orientation={'horizontal'}
            value={this.state.angle}
            renderTrack={track} renderThumb={thumb}
            onChange={value => this.change_angle(value)}
        />
        const center_x_setting = <StyledSlider
            max={2.0} min={-2.0} step={0.01}
            orientation={'horizontal'}
            value={this.state.center_x}
            renderTrack={track} renderThumb={thumb}
            onChange={value => this.change_center_x(value)}
        />
        const center_y_setting = <StyledSlider
            max={2.0} min={-2.0} step={0.01}
            orientation={'horizontal'}
            value={this.state.center_y}
            renderTrack={track} renderThumb={thumb}
            onChange={value => this.change_center_y(value)}
        />
        const operations = [
            {id: OP_SUM, title: "summation"},
            {id: OP_DIFF, title: "difference"},
            {id: OP_PROD, title: "product"},
            {id: OP_DIV, title: "division"},
            {id: OP_POW, title: "power"},
            {id: OP_LOG, title: "log"},
            {id: OP_DIFF_SQ, title: "diff squares"},
        ]
        const operation_options = operations.map(operation =>
            operation.id === this.state.operation ?
                <option value={operation.id} selected>{operation.title}</option> :
                <option value={operation.id}>{operation.title}</option>
        )
        const operation_element = <select onChange={e => this.change_operation(e)}>
            {operation_options}
        </select>
        return <PageWrapper>
            <PageTitle>Moiré</PageTitle>
            <LeftSide>
                <DataSetting title="operation" element={operation_element}/>
                <DataSetting title="zoom" element={zoom_setting}/>
                <DataSetting title="angle" element={angle_setting}/>
                <DataSetting title="center x" element={center_x_setting}/>
                <DataSetting title="center y" element={center_y_setting}/>
            </LeftSide>
            <MiddleSide>
                <PreviewButton onClick={e => this.preview_image()}>Preview</PreviewButton>
                <div>mouse x: {this.state.mouse_x}</div>
                <div>mouse y: {this.state.mouse_y}</div>
            </MiddleSide>
            <RightSide>
                <img
                    src={this.state.preview_url} alt={''}
                    onMouseMove={e => this.on_mouse_over_image(e)}/>
            </RightSide>
        </PageWrapper>
    }
}

export default Moire;
